import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import {
  LeadComponent,
  TrustpilotReviewComponent,
  SendSmsComponent,
  TrialLinkMainComponent,
  ActivationLinkMainComponent,
  ActivationLinkPlansComponent,
  ActivationLinkNewPlansComponent,
  TrialLinkVoiceComponent,
  ActivationLinkUnlimitedVoiceComponent
} from './components';

const routes: Routes = [
  { path: 'lead', component: LeadComponent },
  {
    path: 'trial-link', component: TrialLinkMainComponent,
    children: [
      { path: '', pathMatch: 'full', redirectTo: 'voice' },
      {
        path: 'voice',
        component: TrialLinkVoiceComponent
      },
      { path: '**', pathMatch: 'full', redirectTo: 'voice' },
    ]
  },
  {
    path: 'activation-link', component: ActivationLinkMainComponent,
    children: [
      { path: '', pathMatch: 'full', redirectTo: 'unlimited-users-professionale' },
      {
        path: 'digital-phone-allinclusive',
        component: ActivationLinkPlansComponent
      },
      {
        path: 'essential-professional-prime',
        component: ActivationLinkNewPlansComponent
      },
      {
        path: 'unlimited-users-professionale',
        component: ActivationLinkUnlimitedVoiceComponent
      },
      { path: '**', pathMatch: 'full', redirectTo: 'unlimited-users-professionale' },
    ]
  },
  { path: 'trustpilot-review', component: TrustpilotReviewComponent },
  { path: 'send-sms', component: SendSmsComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SalesRoutingModule { }
